// Adds an upsell item from inside the cart drawer, then swaps in a freshly
// rendered drawer so the line items, the saving, the free-shipping bar and
// the checkout total all update together. Delegated, because the drawer's
// markup is replaced wholesale on every cart change.
document.addEventListener('submit', async (event) => {
  const form = event.target.closest('[data-rp-upsell]');
  if (!form) return;
  event.preventDefault();

  const button = form.querySelector('.rp-upsell__add');
  const picker = form.querySelector('select, input[type="hidden"]');
  const id = picker && picker.value;
  if (!id) return;

  button.setAttribute('aria-busy', 'true');
  try {
    const added = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
    });
    if (!added.ok) throw new Error(await added.text());

    const markup = await (await fetch('/?section_id=cart-drawer')).text();
    const fresh = new DOMParser()
      .parseFromString(markup, 'text/html')
      .querySelector('.drawer__inner');
    const current = document.querySelector('cart-drawer .drawer__inner');
    if (fresh && current) {
      current.replaceWith(fresh);
    } else {
      window.location.reload();
    }
  } catch (error) {
    console.error('[rp-upsell]', error);
    button.removeAttribute('aria-busy');
  }
});
